<template>
  <div class="solution">
    <div class="banner">
      <div class="title">互联网行业解决方案</div>
      <div class="desc">
        <section>为科技互联网品牌搭建全域内容的数字化生产、管理、协作、分发，</section>
        <section>数据管理体系，实现高度的数字化转型升级</section>
      </div>
      <router-link target="_blank"  to='/contact'><div class="button">立即体验<i class="el-icon-right"></i></div></router-link> 
    </div>
    <div class="context">
      <div class="row">
        <div class="introduce right">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>品牌传播大量图文、短视频、tvc、动画等全媒体格式内容定制化需求多，品牌要求</section>
            <section>高，供应商能力参差不齐，交付方式传统；总部设计师在内容创作的过程中需要大量的</section>
            <section>版权素材，成本高且容易遇到版权风险</section>
            <section class='title purple'>解决方案</section>
          <section><span class="marginTop">创意热店：</span>10年连锁经营及消费品牌创意设计服务经验，8大创意服务类型以及150+创</section>
            <section>意服务形式，为品牌提供多元优质的内容创意供给和数字化交付</section>
            <section><span>版权素材：</span>亿级版权素材库，涵盖图片、视频、插画、psd、eps 等格式，为设计师提</section>
            <section>供创意灵感来源，商用场景全覆盖，规避版权风险</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/network/1.png">
      </div>
      <div class="row drak">
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/network/2.png">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>多品牌、跨渠道管理混乱，品牌规范性难以把控</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">品牌规范管理：</span>预设品牌vi规则，包含字体、icon、色值色号等，实现在线管理</section>
            <section><span>权限管理：</span>4级角色权限设置，管理内容的生产，协作，存储，分发及数据权限，保证</section>
            <section>分发内容的品牌合规性</section>
            <section><span>审批管理：</span>标准化的内容分发审批流程，double-check 机制确保内容和品牌的合规</section>
            <section>创作需求</section>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="introduce right">
             <div class="idesc">
            <section class='title'>痛点</section>
            <section>新媒体KOL平台环境复杂，达人质量参差不齐，如何实现精准、高效的投放</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">智能投放：</span>依托kolstore10年的能力沉淀，为品牌提供高度在线标准化的一站式跨平台</section>
            <section>KOL采购</section>
            <section><span>数据监测：</span>新媒体大数据平台 kolrank投放前中后期的数据分析及优化服务，实现品牌营销投放的新增长</section>
          </div>
        </div>
        <img class="img" src="https://respool.isheji.com/isheji/static/qiye/image/solution/network/3.png">
      </div>
        <div class="row drak">
        <img class="img" :src="`https://respool.isheji.com/isheji/static/qiye/image/home/path_card_9.png`">
        <div class="introduce left">
          <div class="idesc">
            <section class='title'>痛点</section>
            <section>企业营销数据系统与内容中台相对独立，效果广告与私域营销内容数据体量庞大，衔接困难</section>
            <section class='title purple'>解决方案</section>
            <section><span class="marginTop">私有化部署：</span>针对企业营销数据系统，部署内容中台数据接口，为企业提供广告投放及</section>
            <section>私域营销的数据分析、管理和回流</section>
            <section><span>可视化数据看板：</span>内容中心超过 100+的数据分析指标，让企业的内容营销数据效果一</section>
            <section>目了然</section>
          </div>
        </div>
      </div>
    </div>
     <banner></banner>
  </div>
</template>
<script>
import banner from '@/components/solutionBanner.vue'
export default {
  name: 'network',
  components: {
    banner,
  },
}
</script>
<style lang="scss" scoped>
.solution{
    width: 100%;
    min-width: 1400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .banner{
      text-align: center;
      background-image: url('https://respool.isheji.com/isheji/static/qiye/image/solution/network/banner.png');
      width: 100%;
      min-width: 1400px;
      background-size: cover;
      height: 460px;
      background-position-x: center;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      padding-top: 60px;
      .title{
        font-size: 32px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 45px;
      }
      .desc{
        margin-top: 20px;
        text-align: center;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 22px;
        margin-bottom: 54px;
      }
     
    }
    .context{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        min-width: 1400px;
      .drak{
        background: #F7F7F9;
      }
      .row{
          padding-top: 120px;
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding-bottom: 115px;
        .left{
          margin-left: 142px;
        }
        .right{
          margin-right: 142px;
        }
        .introduce{
          .iheader{
            display: flex;
            align-items: center;
            img{
              width: 60px;
              height: 60px;
              border-radius: 8px;
            }
            .iTitle{
              margin-left: 18px;
              display: flex;
              flex-direction: column;
              justify-content: center;
            
              .bold{
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 33px;
              }
              .thin{
               font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 22px;
              }
            }
          }
          .idesc{
            margin-top: 24px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #6E6C76;
            line-height: 24px;
            margin-bottom: 32px;
            .marginTop16{
              margin-top: 16px;
            }
            .marginTop{
              margin-top: 0;
            }
            span{
              display: inline-block;
              color: #3B3946;
              font-weight: 600;
              margin-top: 16px;
            }
            .title{
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #3B3946;
                line-height: 28px;
                margin-bottom: 16px;
                margin-top: 32px;
                position: relative;
                padding-left: 16px;
                &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(255, 167, 126, 0) 0%, #FF6E48 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                  left: 0;
                }
            }
            .purple{
              &::before{
                  content: '';
                  width: 30px;
                  height: 30px;
                  background: linear-gradient(270deg, rgba(90, 45, 245, 0) 0%, #5A2DF5 100%);
                  border-radius: 17px;
                  position: absolute;
                  bottom: 0;
                }
            }
          }
        }
        .img{
          width: 595px;
        }
        
      }
    }

     .button{
        width: 126px;
        height: 44px;
        background: #5A2DF5;
        border-radius: 4px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        cursor: pointer;
          .el-icon-right{
            display: none;
            margin-left: 8px;
          }
        &:hover{
          .el-icon-right{
            display: block;
            margin-left: 8px;
            color: #FFFFFF;
          }
        }
      }
}
</style>